/* Ikimsoft - the only JavaScript the storefront needs.
 *
 * Everything else is CSS or native HTML. This file exists for three small
 * things: the mobile drawer, closing the cart drawer, and marking a page as
 * finished loading so the sticky header can settle.
 *
 * No framework, no polyfills, no dependencies. Deferred so it never blocks
 * render, and guarded so a failure here cannot break the page.
 */
(function () {
  'use strict';

  /* ---- mobile navigation drawer -------------------------------------- */
  function initDrawer() {
    var burger = document.querySelector('[data-ik-burger]');
    var drawer = document.getElementById('ik-drawer');
    if (!burger || !drawer) return;

    function setOpen(open) {
      drawer.setAttribute('data-open', String(open));
      burger.setAttribute('aria-expanded', String(open));
    }

    burger.addEventListener('click', function () {
      var open = burger.getAttribute('aria-expanded') === 'true';
      setOpen(!open);
    });

    /* Escape closes it, and focus returns to the button that opened it. */
    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape' && burger.getAttribute('aria-expanded') === 'true') {
        setOpen(false);
        burger.focus();
      }
    });

    /* Tapping any link inside should close it, since navigation follows. */
    drawer.addEventListener('click', function (e) {
      if (e.target.closest('a')) setOpen(false);
    });

    /* A resize past the breakpoint should never leave a hidden drawer open. */
    window.addEventListener('resize', function () {
      if (window.innerWidth > 989) setOpen(false);
    });
  }

  /* ---- sidebar cart --------------------------------------------------- */
  function initCart() {
    var close = document.querySelector('[data-ik-cart-close]');
    var cart = document.getElementById('CartDrawer');
    if (!close || !cart) return;

    function setOpen(open) {
      cart.setAttribute('data-open', String(open));
      document.body.style.overflow = open ? 'hidden' : '';
    }

    close.addEventListener('click', function () { setOpen(false); });
    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape' && cart.getAttribute('data-open') === 'true') {
        setOpen(false);
      }
    });
  }

  function ready(fn) {
    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', fn);
    } else {
      fn();
    }
  }

  ready(function () {
    try {
      initDrawer();
      initCart();
    } catch (e) {
      /* Never let a decorative script break a shopping page. */
      if (window.console) console.error('[ik]', e);
    }
    document.documentElement.setAttribute('data-ik-ready', 'true');
  });
})();
